// extracted by mini-css-extract-plugin
module.exports = {"container":"Generate_container__3uPeV"};